import { Card } from "@common/components/ui/card"
import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { PageContent, PageTitle } from "@/components/page/page-content"
import useCustomToast from "@/hooks/use-custom-toast"
import { FacilityForm } from "./-components/form/facility-form"

export const Route = createFileRoute(
  "/_layout/settings/_panel/workspace/facilities/create",
)({
  staticData: { breadcrumb: "New facility" },
  component: CreateFacilityPage,
})

function CreateFacilityPage(): React.ReactElement {
  const navigate = useNavigate()
  const showToast = useCustomToast()

  return (
    <PageContent>
      <PageTitle title="New facility" />
      <Card className="p-4 shadow-none">
        <FacilityForm
          onCreate={(created) => {
            showToast("Created", `${created.name} added.`, "success")
            navigate({ to: "/settings/workspace/facilities" })
          }}
        />
      </Card>
    </PageContent>
  )
}
